import React, { useContext, useEffect, useState } from "react";
import "./index.scss";
import OfflineBoltOutlinedIcon from "@mui/icons-material/OfflineBoltOutlined";
import FlareOutlinedIcon from "@mui/icons-material/FlareOutlined";
import AirlineStopsOutlinedIcon from "@mui/icons-material/AirlineStopsOutlined";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import CustomTable from "../../core/custom-table";
import CustomModal from "../../core/modal";
import AppContext from "../../utils/context";
import { USER_ROLES } from "../../utils/constants";
import { Icon } from "@iconify/react";
import FaultPieChartContainer from "./pie-chart-container";
const OverviewCards = () => {
  const [selectedCardData, setSelectedCardData] = useState({});
  const [headers, setHeaders] = useState([]);
  const [data, setData] = useState([]);
  const [hmrData, setHmrData] = useState([]);
  const [modelWiseData, setModelWiseData] = useState([]);
  const [selectedCardKey, setSelectedCardKey] = useState("");
  const { userDetails = {} } = useContext(AppContext);
  const { overviewDashboardFilter = {} } = useContext(AppContext);

  const cardList = [
    {
      label: "Model Wise Summary",
      icon: <OfflineBoltOutlinedIcon fontSize="large" />,
      key: "modelWise",
      background: "#ba03fc",
    },
    {
      label: "OEM Wise Failure Summary",
      icon: <FlareOutlinedIcon fontSize="large" />,
      key: "oemWise",
      background: "#eb6302",
    },
    {
      label: "Hour Wise Failure Summary",
      icon: <AirlineStopsOutlinedIcon fontSize="large" />,
      key: "hmrWise",
      background: "#eb6302",
    },
  ];
  const processApiResponse = (response) => {
    // Extract headers dynamically
    const headers = new Set();
    const rows = [];

    Object.entries(response).forEach(([key, value]) => {
      if (key === "undefined") return; // Remove undefined key
      Object.entries(value).forEach(([subKey, count]) => {
        headers.add(subKey);
        rows.push({ issue: key, [subKey]: count ? count : 0 });
      });
    });

    return {
      headers: Array.from(headers).map((header) => ({
        id: header,
        label: header,
      })),
      rows,
    };
  };

  const getModelWiseData = (key, isDownload = false) => {
    const params = isDownload ? { download: "TRUE" } : null;
    const payload = {
      ...overviewDashboardFilter,
    };
    const url =
      userDetails.role === USER_ROLES.OEM
        ? REST_URLS.GET_OEM_MODEL_WISE_REPORT
        : REST_URLS.GET_MODEL_WISE_REPORT;

    invokeApi(
      HTTP_METHODS.POST,
      `${HOSTNAME}${url}`,
      payload,
      params,
      isDownload ? "blob" : null
    )
      .then((res) => {
        if (!res.message) {
          if (isDownload) {
            const url = window.URL.createObjectURL(res);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Model Wise Summary.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          } else {
            // const result = processApiResponse(res);
            // setHeaders([
            //   { id: "issue", label: "Defect Details" },
            //   ...result.headers,
            // ]);
            setModelWiseData(res);
            // const findCard = cardList.find((ele) => ele.key === key);
            // setSelectedCardData(findCard);
          }
        }
      })
      .catch((err) => console.error(err));
  };
  const getOemWiseData = (key, isDownload = false) => {
    const params = isDownload ? { download: "TRUE" } : null;
    const payload = {
      ...overviewDashboardFilter,
    };
    const url =
      userDetails.role === USER_ROLES.OEM
        ? REST_URLS.GET_OEM_WISE_REPORT_FOR_OEM
        : REST_URLS.GET_OEM_WISE_REPORT;
    invokeApi(
      HTTP_METHODS.POST,
      `${HOSTNAME}${url}`,
      payload,
      params,
      isDownload ? "blob" : null
    )
      .then((res) => {
        if (!res.message) {
          if (isDownload) {
            const url = window.URL.createObjectURL(res);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `OEM Wise Failure Summary.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          } else {
            // const result = processApiResponse(res);
            // setHeaders([
            //   { id: "issue", label: "Defect Details" },
            //   ...result.headers,
            // ]);
            setData(res);
            // const findCard = cardList.find((ele) => ele.key === key);
            // setSelectedCardData(findCard);
          }
        }
      })
      .catch((err) => console.error(err));
  };
  console.log(modelWiseData);
  const getHmrWiseData = (key, isDownload = false) => {
    const params = isDownload ? { download: "TRUE" } : null;
    const payload = {
      ...overviewDashboardFilter,
    };
    const url =
      userDetails.role === USER_ROLES.OEM
        ? REST_URLS.GET_OEM_HMR_WISE_REPORT
        : REST_URLS.GET_HMR_WISE_REPORT;
    invokeApi(
      HTTP_METHODS.POST,
      `${HOSTNAME}${url}`,
      payload,
      params,
      isDownload ? "blob" : null
    )
      .then((res) => {
        if (!res.message) {
          if (isDownload) {
            const url = window.URL.createObjectURL(res);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Hour Wise Failure Summary.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
          } else {
            // const result = processApiResponse(res);
            // setHeaders([
            //   { id: "issue", label: "Defect Details" },
            //   ...result.headers,
            // ]);
            setHmrData(res);
            // const findCard = cardList.find((ele) => ele.key === key);
            // setSelectedCardData(findCard);
          }
        }
      })
      .catch((err) => console.error(err));
  };
  const downloadReportHandler = () => {
    switch (selectedCardKey) {
      case "modelWise":
        getModelWiseData(selectedCardKey, true);
        break;
      case "oemWise":
        getOemWiseData(selectedCardKey, true);
        break;
      case "hmrWise":
        getHmrWiseData(selectedCardKey, true);
        break;
      default:
        break;
    }
  };
  const cardClickHandler = (key) => {
    setSelectedCardKey(key);
    switch (key) {
      case "modelWise":
        getModelWiseData("modelWise");
        break;
      case "oemWise":
        getOemWiseData("oemWise");
        break;
      case "hmrWise":
        getHmrWiseData("hmrWise");
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    if (overviewDashboardFilter?.defectCode) {
      getModelWiseData("modelWise");
      getOemWiseData("oemWise");
      getHmrWiseData("hmrWise");
    }
  }, [overviewDashboardFilter]);

  return (
    <div>
      <Typography variant="h6" sx={{ mb: 2, mt: 3 }}>
        Defect Summary
      </Typography>
      {overviewDashboardFilter?.defectCode ? (
        <Grid
          container
          spacing={2}
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Grid item md={4}>
            <Typography sx={{ mb: 1 }}>Model Wise Summary</Typography>
            <FaultPieChartContainer dataMap={modelWiseData} />
          </Grid>
          <Grid item md={4}>
            <Typography sx={{ mb: 1 }}>OEM Wise Summary</Typography>
            <FaultPieChartContainer dataMap={data} />
          </Grid>
          <Grid item md={4}>
            <Typography sx={{ mb: 1 }}>Hour Wise Summary</Typography>
            <FaultPieChartContainer dataMap={hmrData} />
          </Grid>
          {/* {cardList?.map((card) => {
          return (
            <Grid
              item
              md={6}
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <div
                className="overview-report-card-con"
                style={{ background: card.background }}
                onClick={() => cardClickHandler(card.key)}
              >
                {card.icon}
              </div>
              <Typography
                variant="h6"
                sx={{ lineHeight: 1.1, textAlign: "center", mt: 1 }}
              >
                {card.label}
              </Typography>
            </Grid>
          );
        })} */}
        </Grid>
      ) : (
        <Typography sx={{ textAlign: "center" }}>
          Select Defect Code for Summary
        </Typography>
      )}

      {/* {Object.keys(selectedCardData).length > 0 && (
        <CustomModal
          title={selectedCardData?.label}
          onClose={() => {
            setSelectedCardData({});
            setHeaders([]);
            setData([]);
          }}
          classesToPreventClosing={["MuiAutocomplete-option Mui-focused"]}
          contentClassName="custom-modal-dashboard-content"
        >
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton onClick={downloadReportHandler}>
              <Icon
                icon="tabler:download"
                width="1.5rem"
                height="1.5rem"
                style={{ color: "#095adc" }}
              />
            </IconButton>
          </Box>
          <FaultPieChartContainer dataMap={data} />
        </CustomModal>
      )} */}
    </div>
  );
};

export default OverviewCards;
